<template>
  <div id="footersection" class="grey-background-darker">
    <v-container class="pt-10 mb-15 px-6">
      <v-row class="align-top mt-8">
        <v-col class="col-sm-6 col-md-3 col-12">
          <v-img :src="require('@/assets/techsoup_logo_default.png')" class="mb-2 mr-4 mb-4" max-width="150"></v-img>
          <p class="body-2 ts_dark_grey--text">
            Techsoup Italia
            <br />Via Bergognone, 34
            <br />@Cariplo Factory
            <br />20144 Milano
          </p>
        </v-col>

        <v-col class="col-sm-6 col-md-3 col-12">
          <h3 class="mb-2">CONOSCI TECHSOUP</h3>
          <v-divider class="primary mb-6" style="max-width: 28px; border: 2px solid"></v-divider>
          <a
            v-for="how in hows"
            :key="how.title"
            :text="how.title"
            class="mb-3 body-2 d-block font-weight-light ts_dark_grey--text"
            style="text-decoration: none;"
            :href="how.link"
            target="_blank"
            v-html="`${how.title}`"
          />
        </v-col>

        <v-col class="col-sm-6 col-md-3 col-12">
          <h3 class="mb-2">CONTATTACI</h3>
          <v-divider class="primary mb-6" style="max-width: 28px; border: 2px solid"></v-divider>
          <a
            v-for="contact in contacts"
            :key="contact.title"
            :text="contact.title"
            class="mb-3 grey--text body-2 d-block font-weight-light ts_dark_grey--text"
            style="text-decoration: none;"
            :href="contact.link"
            v-html="`${contact.title}`"
          />
        </v-col>

        <v-col class="col-sm-6 col-md-3 col-12">
          <h3 class="mb-2">SEGUICI</h3>
          <v-divider class="primary mb-3" style="max-width: 28px; border: 2px solid"></v-divider>
          <v-btn icon color="grey" :href="icon.link" target="_blank" v-for="icon in social_icons" :key="icon.title">
            <v-icon>{{icon.title}}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-footer style="background-color: white" class="ts_dark_grey--text">
      <div class="caption d-flex">
        <a
          v-for="link in legal_links"
          :key="link.title"
          :text="link.title"
          class="mr-1 caption d-block ts_dark_grey--text"
          style="text-decoration: none;"
          href="#"
          v-html="`${link.title}`"
        />
      </div>
      <v-spacer></v-spacer>
      <div
        class="caption"
      >&copy; {{ new Date().getFullYear() }} Copyright SocialTechno Impresa Sociale srl. P.IVA 08722650960</div>
    </v-footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hows: [
        { title: "Come funziona Techsoup",
          link: "https://www.techsoup.it/come-funziona-la-piattaforma-techsoup" },
        { title: "Catalogo prodotti",
          link: "https://www.techsoup.it/product-catalog" },
        { title: "Chi siamo",
          link: "https://www.techsoup.it/team" }
        ],
      contacts: [
        { title: "Dubbi o domande?",
          link: "" },
        { title: "marketing@techsoup.it",
          link: "mailto:marketing@techsoup.it" }
        ],
      // other_links: [
      //   { title: "Speakers",
      //     link: "" },
      //   { title: "Topics",
      //     link: "" }
      // ],
      legal_links: [
        { title: "Cookie Policy |",
          link: "" },
        { title: "Normativa sulla privacy",
          link: "" }
      ],
      social_icons: [
        { title: "mdi-facebook",
          link: "https://www.facebook.com/TechSoupItalia"},
        { title: "mdi-twitter",
          link: "https://twitter.com/TechSoupItalia" },
        { title: "mdi-linkedin",
          link: "https://it.linkedin.com/company/techsoup-italia" },
        { title: "mdi-instagram",
          link: "https://www.instagram.com/TechSoupItalia/" },
        { title: "mdi-youtube",
          link: "https://www.youtube.com/channel/UCg-d2n6t6Txa7lsKOYENaSQ" },
      ],
    };
  }
};
</script>

<style>
.grey-background-darker {
  background-color: #E6E6E6 !important;
}
</style>